import Konva from 'konva'
import {
  SpecName,
  isBanEditNode,
  isSelectedShape,
  setNodeHoverClass,
  isBanSelectNode,
  isAllowBoxSelection,
  allowBeSelected,
} from '@ps/store/workbench/stage/config/layer-config'
// @ts-ignore
import qc from 'qc'
import {
  hadChildren,
  isSequenceFrame,
  isText,
  isNodeGhost,
  isQuickLayout,
  isDrawLineNode,
  isCarouselGroup,
  getCarouselNodeInScene,
} from '@ps/bridge/qc/base'
import { getScript, removeScript } from '@ps/bridge/qc/scripts/edit-text'
import {
  convertNode2Dom,
  covertShapeRotation2Node,
  getNodeByShape,
  haveFatherSonRelationship,
  haveIntersection,
  insertHtml,
} from '@ps/store/workbench/stage/utils/helper'
import { ActionContext } from 'vuex'
import { RootState } from '@ps/types/store'
import { deg2rad, rad2deg } from '@com/utils/unit-converters/angle'
import { moveNodeByWorldPosition, getScaleShapeDelta } from '@ps/bridge/qc/node'
import { EventBus, Event } from '@ps/utils/event-bus'
import StageData from '@ps/store/workbench/stage/stage-data'
import { hasPermission } from '@ps/plugins/permission-manager/manager'
import keys from '@ps/permission/keys'
import { StageState } from '@ps/types/workbench/stage.type'
import { Vector2d } from 'konva/lib/types'
import * as movieClipScript from '@ps/bridge/qc/scripts/movie-clip'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import nodePool from '@ps/bridge/qc/node-pool'
import {
  AllowGroupLinkage,
  isTransformByScale,
} from '@ps/store/workbench/common/node-utils'
import { resetAndStopAnimation } from '@ps/bridge/qc/node'
import hotkeys from 'hotkeys-js'
interface tempData {
  uuid?: string // 节点 uuid
  rotation?: number // shape 旋转角度
  width?: number // shape 宽度，缩放时使用
  height?: number // shape 高度，缩放时使用
  scaleX?: number // shape x 方向缩放比例
  scaleY?: number // shape y 方向缩放比例
  x?: number // shape x
  y?: number // shape y
  nodeX?: number // node 节点的世界坐标中心点
  nodeY?: number // node 节点的世界坐标中心点
  nodeScaleX?: number // node 节点的 scaleX
  nodeScaleY?: number // node 节点的 scaleY
  nodeWidth?: number // node 节点宽度
  nodeHeight?: number // node 节点高度
  nodeRotation?: number // node 节点的世界坐标旋转弧度
  linkageNodeX?: number // 联动节点的世界坐标中心点 X
  linkageNodeY?: number // 联动节点的世界坐标中心点 Y
}

let isChangeRotation = false

/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default {
  addSelectionListener({
    commit,
    rootState,
    dispatch,
  }: ActionContext<StageState, RootState>): void {
    const KonvaStage = StageData.stage as Konva.Stage
    const KonvaSelectionRectangle = StageData.selectionRectangle as Konva.Rect
    const KonvaTransformer = StageData.transformer as Konva.Transformer

    let x1: number, y1: number, x2: number, y2: number

    KonvaStage.on('mousedown', async (e) => {
      if (e.target !== KonvaStage) {
        // 如果当前操作的元素是自定义元素，则直接选中
        if (e.target.hasName(SpecName)) {
          const shape: Konva.Rect = e.target as Konva.Rect
          // do we pressed shift or ctrl?
          const metaPressed = e.evt.ctrlKey || e.evt.metaKey || e.evt.shiftKey
          if (!metaPressed && isSelectedShape(shape)) return
          // 是否动画编辑结束状态开启
          const isAnimationEditEnd =
            metaPressed &&
            rootState.workspace.animation.tweenPositionAreaActived
          if (isAnimationEditEnd) return
          // setTimeout 修复该问题 在外观修改了文本，立即选中元素，修改文本不生效
          // 需要保证更改activeNode在输入框的change之后触发
          let resShape = shape
          // 按ctrl或command键点选元素时直接穿透父元素选取最里面的子元素
          if (hotkeys.isPressed('command') || hotkeys.isPressed('ctrl')) {
            const node = getNodeByShape(shape)
            // 当前点击的坐标
            const Vector: Vector2d = {
              x: KonvaStage.getPointerPosition()?.x ?? 0,
              y: KonvaStage.getPointerPosition()?.y ?? 0,
            }
            // 如果双击的是组节点，则激活组节点并且隐藏选择框
            // 龙骨节点有子节点，但是不是组元素，所以需要兼容
            // 连线组件即使有子节点，也不是组元素，所以需要兼容
            const allowDblClick = (node: qc.Node) => {
              return hadChildren(node) && !isDrawLineNode(node)
            }
            if (allowDblClick(node)) {
              commit('addActivationShape', shape)
              commit('toggleActivationShapeVisible', false)
              const shapes: Konva.Rect[] = KonvaStage.find(`.${SpecName}`)
              // 获取当前组节点的所有子节点中与当前点击坐标有交集的集合
              const childrenShapes = shapes.filter((item) => {
                return (
                  shape !== item &&
                  item.visible() &&
                  haveFatherSonRelationship(shape, item) &&
                  haveIntersection({
                    shape: item,
                    Vector: Vector,
                  })
                )
              })
              if (childrenShapes.length) {
                resShape = childrenShapes[0] // 取group最里面的元素
              }
            }
          }
          setTimeout(() => {
            dispatch('updateSelectionByShape', {
              shape: resShape,
              multiple: metaPressed,
            })
          }, 0)
        }
      } else {
        x1 = KonvaStage.getPointerPosition()?.x ?? 0
        y1 = KonvaStage.getPointerPosition()?.y ?? 0
        x2 = KonvaStage.getPointerPosition()?.x ?? 0
        y2 = KonvaStage.getPointerPosition()?.y ?? 0

        KonvaSelectionRectangle.visible(true)
        KonvaSelectionRectangle.width(0)
        KonvaSelectionRectangle.height(0)
      }
    })

    KonvaStage.on('click', (e) => {
      if (e.target !== KonvaStage) {
        // 包含特殊标识，说明都是项目中新建的 konva.rect
        if (e.target.hasName(SpecName)) {
          const shape: Konva.Rect = e.target as Konva.Rect
          const Vector: Vector2d = {
            x: KonvaStage.getPointerPosition()?.x ?? 0,
            y: KonvaStage.getPointerPosition()?.y ?? 0,
          }
          // 当存在激活组节点的时候，判断当前点击的坐标是否与激活组节点有交集，如果没有，则取消激活状态
          if (StageData.activationShape.length > 0) {
            const havaRelationship = StageData.activationShape.some((item) => {
              return haveIntersection({
                shape: item,
                Vector: Vector,
              })
            })
            if (!havaRelationship) {
              commit('toggleActivationShapeVisible', true)
            }
          }
          if (isBanSelectNode(shape)) {
            return
          }
          if (isSelectedShape(shape)) {
            setNodeHoverClass(shape, false)
          } else {
            setNodeHoverClass(shape, true)
          }
        }
      } else {
        commit('toggleActivationShapeVisible', true)
      }
    })

    KonvaStage.on('mousemove', () => {
      // no nothing if we didn't start selection
      if (!KonvaSelectionRectangle.visible()) {
        return
      }
      x2 = KonvaStage.getPointerPosition()?.x ?? 0
      y2 = KonvaStage.getPointerPosition()?.y ?? 0

      KonvaSelectionRectangle.setAttrs({
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1),
      })
    })

    KonvaStage.on('dblclick', async (e) => {
      // 包含特殊标识，说明都是项目中新建的 konva.rect
      if (e.target.hasName(SpecName)) {
        const shape: Konva.Rect = e.target as Konva.Rect
        const node = getNodeByShape(shape)
        // 当前点击的坐标
        const Vector: Vector2d = {
          x: KonvaStage.getPointerPosition()?.x ?? 0,
          y: KonvaStage.getPointerPosition()?.y ?? 0,
        }
        // 如果双击的是组节点，则激活组节点并且隐藏选择框
        // 龙骨节点有子节点，但是不是组元素，所以需要兼容
        // 连线组件即使有子节点，也不是组元素，所以需要兼容
        const allowDblClick = (node: qc.Node) => {
          return hadChildren(node) && !isDrawLineNode(node)
        }
        if (allowDblClick(node)) {
          commit('addActivationShape', shape)
          commit('toggleActivationShapeVisible', false)
          const shapes: Konva.Rect[] = KonvaStage.find(`.${SpecName}`)
          // 获取当前组节点的所有子节点中与当前点击坐标有交集的集合
          const childrenShapes = shapes.filter((item) => {
            return (
              shape !== item &&
              item.visible() &&
              haveFatherSonRelationship(shape, item) &&
              haveIntersection({
                shape: item,
                Vector: Vector,
              })
            )
          })
          if (childrenShapes.length) {
            await dispatch('updateSelectionByShape', {
              shape: childrenShapes[childrenShapes.length - 1],
            })
          } else {
            await dispatch(
              'workspace/game/clearActiveNode',
              {
                record: true,
              },
              {
                root: true,
              },
            )
          }
        }
      }
    })

    KonvaStage.on('mouseup', (e) => {
      // no nothing if we didn't start selection
      if (!KonvaSelectionRectangle.visible()) {
        return
      }
      // update visibility in timeout, so we can check it in click event
      setTimeout(() => {
        KonvaSelectionRectangle.visible(false)
      })

      const shapes: Konva.Rect[] = KonvaStage.find(`.${SpecName}`)
      const box = KonvaSelectionRectangle.getClientRect()
      const selected = shapes.filter((shape) => {
        return (
          isAllowBoxSelection(shape) &&
          Konva.Util.haveIntersection(box, shape.getClientRect())
        )
      })
      const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey
      dispatch('updateSelectionByShapeList', { shapes: selected, metaPressed })
    })

    KonvaTransformer.findOne('.rotater').on('mousedown', () => {
      isChangeRotation = true
    })

    window.addEventListener('mouseup', () => {
      isChangeRotation = false
    })
  },

  addVirtualNodeListener(
    {
      state,
      dispatch,
      rootState,
      commit,
    }: ActionContext<StageState, RootState>,
    shape: Konva.Rect,
  ): void {
    const node = getNodeByShape(shape)

    // 缓存画布世界缩放值，该值在画布生成后基本不会变动
    const worldScale = rootState.workspace.game.device.worldScale
    const KonvaTransformer = StageData.transformer as Konva.Transformer
    const KonvaLayer = StageData.layer as Konva.Layer

    const isBlockHoverEvent = (): boolean => {
      return (
        isBanEditNode(node) ||
        isSelectedShape(shape) ||
        state.isFocusin ||
        state.isTransform
      )
    }

    const refreshCarousel = () => {
      console.log('刷新轮播组件')
      const currentSceneNode = rootState.workspace.sceneManager
        .currentSceneNode as qc.Node
      const carouselNode = getCarouselNodeInScene(currentSceneNode) as qc.Node
      if (isCarouselGroup(node, carouselNode)) {
        EventBus.$emit(Event.REFRESHCAROUSEL)
        // dispatch('workspace/game/resetCarousel', {}, { root: true })
      }
    }

    // hover 高亮效果
    shape.on('mouseover', function () {
      if (isBlockHoverEvent()) return
      setNodeHoverClass(this, true)
    })
    shape.on('mouseout', function () {
      if (isBlockHoverEvent()) return
      setNodeHoverClass(this, false)
    })

    let isMovieClipPlaying = false

    // 起始状态下执行事件，包含变换起始和拖拽起始
    const startHook = (): void => {
      if (isSequenceFrame(node)) {
        isMovieClipPlaying = movieClipScript.getScript(node)!.isPlaying
        dispatch('workspace/game/sequenceManager/stopAction', node, {
          root: true,
        })
      }
    }

    // 结束状态下执行事件，包含变换起始和拖拽起始
    const endHook = (): void => {
      if (isSequenceFrame(node) && isMovieClipPlaying) {
        // 如果没有延迟 100 ms 重新播放，会有跳动的问题，99ms 都不行，为了保险起见，设置 150ms
        setTimeout(() => {
          dispatch('workspace/game/sequenceManager/playAction', node, {
            root: true,
          })
        }, 150)
      }
      setTimeout(() => {
        refreshCarousel()
      }, 150)
    }

    // 临时数据，变换形状时使用
    let transformTempData: tempData = {}
    // 记录组内元素的位置信息，缩放时同步修改
    let groupItemTempData: tempData[] = []
    const transformTempDataFactory = ({
      shape,
      node,
    }: {
      shape?: Konva.Rect
      node?: qc.Node
    }): tempData => {
      let temp = {}
      if (shape) {
        temp = {
          ...temp,
          x: shape.x(),
          y: shape.y(),
          rotation: shape.rotation(),
          width: shape.width(),
          height: shape.height(),
          scaleX: shape.scaleX(),
          scaleY: shape.scaleY(),
        }
      }
      if (node) {
        temp = {
          ...temp,
          uuid: node.uuid,
          nodeWidth: node.width,
          nodeHeight: node.height,
          nodeX: node.getWorldPosition().x,
          nodeY: node.getWorldPosition().y,
          nodeScaleX: node.scaleX,
          nodeScaleY: node.scaleY,
          nodeRotation: node.rotation,
        }
      }
      return temp
    }
    // 缩放、旋转事件
    shape.on('transformstart', async () => {
      if (isBanEditNode(node)) return
      startHook()
      state.isTransform = true
      // 记录开始状态的数据
      transformTempData = transformTempDataFactory({
        shape,
        node,
      })
      // 记录状态保证回滚
      state.preStyle.push({
        uuid: node.uuid,
        x: node.x,
        y: node.y,
        width: node.width,
        height: node.height,
        scaleX: node.scaleX,
        scaleY: node.scaleY,
        rotation: rad2deg(node.rotation),
      })
      if (hadChildren(node) && AllowGroupLinkage(node)) {
        groupItemTempData = []
        const childNodes = getDescendants(node, false)
        childNodes.forEach((childNode) => {
          if (allowBeSelected(childNode)) {
            groupItemTempData.push(
              transformTempDataFactory({ node: childNode }),
            )
            // 记录状态保证回滚, 只支持缩放，不支持旋转， 但是 isChangeRotation 的标识在 transformstart 时还未赋值，所以先保存所有数据
            state.preStyle.push({
              uuid: childNode.uuid,
              x: childNode.x,
              y: childNode.y,
              width: childNode.width,
              height: childNode.height,
              scaleX: childNode.scaleX,
              scaleY: childNode.scaleY,
            })
          }
        })
      }
    })
    shape.on('transform', async () => {
      if (isBanEditNode(node)) return
      // 判断当前节点是否是缩放时改动缩放值
      const changeByScale = isTransformByScale(node)
      const sceneScale: number = rootState.workspace.game.device.scale
      // 变换偏移值
      const deltaScaleX =
        (shape.width() * shape.scaleX()) /
        (transformTempData.width! * transformTempData.scaleX!)
      const deltaScaleY =
        (shape.height() * shape.scaleY()) /
        (transformTempData.height! * transformTempData.scaleY!)
      // 因为游戏引擎缩放是根据节点的中心点进行缩放
      const deltaX = (shape.x() - transformTempData.x!) / sceneScale
      const deltaY = (shape.y() - transformTempData.y!) / sceneScale
      const deltaRotation =
        covertShapeRotation2Node(shape.rotation()) -
        covertShapeRotation2Node(transformTempData.rotation!)
      // 只有非旋转的缩放操作才需要更新 x, y 值
      if (!isChangeRotation) {
        moveNodeByWorldPosition({
          node: node,
          x: transformTempData.nodeX! + deltaX,
          y: transformTempData.nodeY! + deltaY,
        })
      } else {
        shape.x(transformTempData.x!)
        shape.y(transformTempData.y!)
      }
      node.rotation = transformTempData.nodeRotation! + deg2rad(deltaRotation)
      const nodesStyle: {
        uuid: string
        width: number
        height: number
        x: number
        y: number
        scaleX?: number
        scaleY?: number
        rotation?: number
      }[] = [
        {
          uuid: node.uuid,
          width: changeByScale
            ? transformTempData.nodeWidth!
            : transformTempData.nodeWidth! * deltaScaleX,
          height: changeByScale
            ? transformTempData.nodeHeight!
            : transformTempData.nodeHeight! * deltaScaleY,
          x: node.x,
          y: node.y,
          scaleX: changeByScale
            ? transformTempData.nodeScaleX! * deltaScaleX
            : transformTempData.nodeScaleX!,
          scaleY: changeByScale
            ? transformTempData.nodeScaleY! * deltaScaleY
            : transformTempData.nodeScaleY!,
          rotation: covertShapeRotation2Node(rad2deg(node.rotation)),
        },
      ]
      // 如果是含有子节点, 并且是缩放操作，需要缩放子节点
      if (
        hadChildren(node) &&
        !isChangeRotation &&
        AllowGroupLinkage(node) &&
        groupItemTempData.length
      ) {
        const childNodes = getDescendants(node, false)
        childNodes.forEach((childNode) => {
          if (allowBeSelected(childNode)) {
            // 判断当前子节点是否是缩放时改动缩放值
            const changeByScale = isTransformByScale(childNode)
            const childTempDate = groupItemTempData.find(
              (data) => data.uuid === childNode.uuid,
            )
            if (childTempDate) {
              const childDelta = getScaleShapeDelta(
                [childTempDate.nodeX!, childTempDate.nodeY!],
                [transformTempData.nodeX!, transformTempData.nodeY!],
                transformTempData.nodeRotation!,
                [deltaScaleX, deltaScaleY],
                [deltaX, deltaY],
              )
              moveNodeByWorldPosition({
                node: childNode,
                x: childTempDate.nodeX! + childDelta[0],
                y: childTempDate.nodeY! + childDelta[1],
              })
              nodesStyle.push({
                uuid: childNode.uuid,
                width: changeByScale
                  ? childTempDate.nodeWidth!
                  : childTempDate.nodeWidth! * deltaScaleX,
                height: changeByScale
                  ? childTempDate.nodeHeight!
                  : childTempDate.nodeHeight! * deltaScaleY,
                x: childNode.x,
                y: childNode.y,
                scaleX: changeByScale
                  ? childTempDate.nodeScaleX! * deltaScaleX
                  : childNode.scaleX,
                scaleY: changeByScale
                  ? childTempDate.nodeScaleY! * deltaScaleY
                  : childNode.scaleY,
              })
            }
          }
        })
      }
      if (shape.attrs.textConfig) {
        const text = KonvaLayer.findOne(`#${shape.attrs.textConfig.id}`)
        if (text) {
          text.setAttrs({
            x: shape.x() - (shape.width() * shape.scaleX()) / 2,
            y: shape.y() - (shape.height() * shape.scaleY()) / 2,
          })
        }
      }
      if (shape.attrs.suffixConfig) {
        const suffix = KonvaLayer.findOne(`#${shape.attrs.suffixConfig.id}`)
        if (suffix) {
          suffix.setAttrs({
            x: shape.x() - (shape.width() * shape.scaleX()) / 2,
            y: shape.y() - (shape.height() * shape.scaleY()) / 2,
          })
        }
      }
      await dispatch(
        'workspace/game/setStyle',
        {
          nodes: nodesStyle,
          record: false,
        },
        { root: true },
      )
      // 实时刷新棋盘内容
      if (isQuickLayout(node)) {
        dispatch('workspace/layoutEditor/grid/gridNodeResize', node, {
          root: true,
        })
      }
    })
    shape.on('transformend', async () => {
      if (isBanEditNode(node)) return
      state.isTransform = false
      // 记录状态保证回滚
      state.afterStyle.push({
        uuid: node.uuid,
        x: node.x,
        y: node.y,
        width: node.width,
        height: node.height,
        scaleX: node.scaleX,
        scaleY: node.scaleY,
        rotation: rad2deg(node.rotation),
      })
      // 如果是组节点并且是缩放操作，需要记录子节点信息
      if (hadChildren(node) && !isChangeRotation && AllowGroupLinkage(node)) {
        groupItemTempData = []
        const childNodes = getDescendants(node, false)
        childNodes.forEach((childNode) => {
          if (allowBeSelected(childNode)) {
            // 记录状态保证回滚, 只支持缩放，不支持旋转
            state.afterStyle.push({
              uuid: childNode.uuid,
              x: childNode.x,
              y: childNode.y,
              width: childNode.width,
              height: childNode.height,
              scaleX: childNode.scaleX,
              scaleY: childNode.scaleY,
            })
          }
        })
      }
      await dispatch('updateNodeStyle')
      // 尝试清理动画虚拟节点
      dispatch('workspace/animation/destroyAndAddGhost', {}, { root: true })
      // 当前操作节点为轮播节点，修改尺寸后需要刷新轮播组件

      endHook()
    })
    shape.on('dragstart', function () {
      if (isBanEditNode(node)) return
      state.isTransform = true
      // 虚拟节点拖拽，激活节点进行循环动画会导致坐标错乱，开始拖拽停止节点动画
      if (isNodeGhost(node)) {
        resetAndStopAnimation(rootState.workspace.game.activeNode)
      }
      startHook()

      // 记录开始状态
      transformTempData = {
        x: shape.x(),
        y: shape.y(),
        nodeX: node.getWorldPosition().x,
        nodeY: node.getWorldPosition().y,
      }
      // 记录状态保证回滚
      state.preStyle.push({
        uuid: node.uuid,
        x: node.x,
        y: node.y,
      })
      // 如果含有存在拖拽联动的节点 id, 需要记录联动节点的 uuid 和开始状态
      if (shape.attrs.dragLinkage) {
        const dragLinkNode = nodePool.find(shape.attrs.dragLinkage)
        if (dragLinkNode) {
          transformTempData.linkageNodeX = dragLinkNode.getWorldPosition().x
          transformTempData.linkageNodeY = dragLinkNode.getWorldPosition().y
          state.preStyle.push({
            uuid: dragLinkNode.uuid,
            x: dragLinkNode.x,
            y: dragLinkNode.y,
          })
        }
      }
    })
    shape.on('dragmove', async (e) => {
      if (isBanEditNode(node)) return
      state.isTransform = true
      if (shape.attrs.textConfig) {
        const text = KonvaLayer.findOne(`#${shape.attrs.textConfig.id}`)
        if (text) {
          requestAnimationFrame(() => {
            text.setAttrs({
              x: shape.x() - (shape.width() * shape.scaleX()) / 2,
              y: shape.y() - (shape.height() * shape.scaleY()) / 2,
            })
          })
        }
      }
      if (shape.attrs.suffixConfig) {
        const suffix = KonvaLayer.findOne(`#${shape.attrs.suffixConfig.id}`)
        if (suffix) {
          requestAnimationFrame(() => {
            suffix.setAttrs({
              x: shape.x() - (shape.width() * shape.scaleX()) / 2,
              y: shape.y() - (shape.height() * shape.scaleY()) / 2,
            })
          })
        }
      }
      if (!shape.attrs.syncStyle) return
      const sceneScale: number = rootState.workspace.game.device.scale
      let deltaX = (shape.x() - transformTempData.x!) / sceneScale
      let deltaY = (shape.y() - transformTempData.y!) / sceneScale
      const metaPressed = e.evt.shiftKey
      // 当点了 shift 之后，只偏移偏移值最高的方向，
      if (metaPressed) {
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          shape.y(transformTempData.y!)
          deltaY = 0
        } else {
          shape.x(transformTempData.x!)
          deltaX = 0
        }
      }
      moveNodeByWorldPosition({
        node: node,
        x: transformTempData.nodeX! + deltaX,
        y: transformTempData.nodeY! + deltaY,
      })
      if (shape.attrs.dragLinkage) {
        const dragLinkNode = nodePool.find(shape.attrs.dragLinkage)
        if (dragLinkNode) {
          moveNodeByWorldPosition({
            node: dragLinkNode,
            x: transformTempData.linkageNodeX! + deltaX,
            y: transformTempData.linkageNodeY! + deltaY,
          })
          dispatch('resetShapeLayout', dragLinkNode)
        }
      }
    })
    shape.on('dragend', async () => {
      if (isBanEditNode(node)) return
      state.isTransform = false
      // 记录状态保证回滚
      state.afterStyle.push({
        uuid: node.uuid,
        x: node.x,
        y: node.y,
      })
      if (shape.attrs.dragLinkage) {
        const dragLinkNode = nodePool.find(shape.attrs.dragLinkage)
        if (dragLinkNode) {
          state.afterStyle.push({
            uuid: dragLinkNode.uuid,
            x: dragLinkNode.x,
            y: dragLinkNode.y,
          })
        }
      }
      await dispatch('updateNodeStyle')
      // 激活编辑动画开关
      if (rootState.workspace.animation.tweenPositionAreaActived) {
        dispatch(
          'workspace/animation/updateCurrentAnimation',
          {
            x: node.x,
            y: node.y,
          },
          {
            root: true,
          },
        )
      }
      endHook()
    })

    // 只有文本节点允许可视化编辑
    // 检验是否有编辑文本的权限
    if (isText(node) && hasPermission(keys.editTextValue)) {
      shape.on('dblclick', function () {
        // 隐藏画布里面的节点与移除选中状态
        KonvaTransformer.hide()
        getScript(node)
        node.visible = false
        const textShape = shape
        const KonvaStage = StageData.stage as Konva.Stage
        const sceneScale: number = rootState.workspace.game.device.scale

        setNodeHoverClass(textShape, true)

        // create textarea and style it
        const textarea = document.createElement('div')
        KonvaStage.container().appendChild(textarea)

        convertNode2Dom(
          textarea,
          node as qc.UIText,
          textShape,
          sceneScale,
          worldScale.x,
        )

        setTimeout(function () {
          textarea.focus()

          if (textarea.hasChildNodes()) {
            // if the element is not empty
            const s = window.getSelection()
            const r = document.createRange()
            const e =
              textarea.childElementCount > 0 ? textarea.lastChild : textarea
            if (e) {
              r.setStart(e, 1)
              r.setEnd(e, 1)
            }
            if (s) {
              s.removeAllRanges()
              s.addRange(r)
            }
          }
        }, 0)

        async function removeTextarea() {
          if (textarea.parentNode) {
            textarea.parentNode.removeChild(textarea)
          }
          setNodeHoverClass(textShape, false)
          window.removeEventListener('click', handleOutsideClick)
          const textContent = textarea.textContent
            ? textarea.textContent.replace(/<br>/g, '\n')
            : ''
          dispatch(
            'workspace/game/setText',
            {
              node: node,
              value: textContent,
            },
            {
              root: true,
            },
          )
          dispatch(
            'workspace/language/updateLanguageConfigByNode',
            {
              lang: rootState.workspace.language.currentLanguage,
              node: node,
            },
            {
              root: true,
            },
          )
          // 回滚选中状态与移除脚本
          KonvaTransformer.show()
          removeScript(node)
          node.visible = true
        }

        textarea.addEventListener('keydown', function (e) {
          // hide on enter
          // but don't hide on shift + enter
          if (e.keyCode === 13) {
            insertHtml('<br>')
            e.preventDefault()
          }
        })

        function handleOutsideClick(e: Event) {
          if (e.target !== textarea) {
            // 输入文本时触发场景截图，保持截图内容一致
            setTimeout(() => {
              EventBus.$emit(Event.CAPTUREGAME)
            }, 100)
            removeTextarea()
          }
        }

        setTimeout(() => {
          window.addEventListener('click', handleOutsideClick)
        })
      })
    }
  },
}
